import { ActionListModel } from "@genexus/chameleon-controls-library/dist/types/components/action-list/types";

/**
 * Order the items in the same order as they come.
 */
export const sortActionListDefault = (subModel: ActionListModel) => {
  return subModel;
};
